import {
  useModalContext,
  WSButton,
  WSButtons,
  WSModal,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import {
  useSetLostCard,
  useSetStolenCard
} from "../../../query/payments/mutations";
import { CREATE_PHYSICAL_DEBIT_CARD_MODAL } from "../components/BankCardsList/CreatePhysicalCard";
import { WSErrorMessage } from "../../../components/WSErrorMessage/WSErrorMessage";
import { ErrorContextKey } from "../../../services/platform";

export const LOST_OR_STOLEN_CONFIRMATION_MODAL =
  "LOST_OR_STOLEN_CONFIRMATION_MODAL";

const Inner: React.FC<{ cardId: string }> = props => {
  const { closeModal, openModal } = useModalContext();

  const [setStolen, setStolenMeta] = useSetStolenCard();
  const [setLost, setLostMeta] = useSetLostCard();

  return (
    <>
      <WSText.Heading5 mb="XL">What happened to the card?</WSText.Heading5>
      <WSText>This information helps us sort requests for new cards.</WSText>

      <WSErrorMessage
        mt="XL"
        error={setStolenMeta.error || setLostMeta.error}
        contextKey={ErrorContextKey.Other}
      />

      <WSButtons mt="XL" format="modal">
        <WSButton.Primary
          onAsyncClick={async () => {
            await setStolen(props.cardId, {
              onSuccess() {
                closeModal(LOST_OR_STOLEN_CONFIRMATION_MODAL);
                openModal(CREATE_PHYSICAL_DEBIT_CARD_MODAL, {
                  isReplace: true,
                  onSuccess() {},
                  cardId: props.cardId
                });
              }
            });
          }}
        >
          Stolen
        </WSButton.Primary>
        <WSButton.Secondary
          onAsyncClick={async () => {
            await setLost(props.cardId, {
              onSuccess() {
                closeModal(LOST_OR_STOLEN_CONFIRMATION_MODAL);
                openModal(CREATE_PHYSICAL_DEBIT_CARD_MODAL, {
                  isReplace: true,
                  onSuccess() {},
                  cardId: props.cardId
                });
              }
            });
          }}
        >
          Lost
        </WSButton.Secondary>
      </WSButtons>
    </>
  );
};

export const LostOrStolenConfirmation: React.FC<{ cardId: string }> = props => {
  const { closeModal } = useModalContext();

  return (
    <WSModal
      name={LOST_OR_STOLEN_CONFIRMATION_MODAL}
      size="XS"
      onClose={() => closeModal(LOST_OR_STOLEN_CONFIRMATION_MODAL)}
    >
      <Inner cardId={props.cardId} />
    </WSModal>
  );
};
